




































































import Vue from 'vue';

export default Vue.extend({
  name: 'ReasonPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: String,

    label: {
      type: String,
      default: 'Reasons'
    },

    showCustomReasonField: {
      type: Boolean,
      default: () => false
    },

    reasonOptions: {
      type: Array,
      default: () => []
    },

    externalErrorMessage: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: ''
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    }
  },
  methods: {
    toggleShowCustomReasonField() {
      //clear to input value when switching between components to prevent confusion for user
      this.clearInputValue();
      this.$emit('update:showCustomReasonField', !this.showCustomReasonField);
    },

    clearInputValue() {
      this.internalValue = '';
      this.search = '';
    }
  }
});
